type AssetPointer = { url: string };

import { DEFAULT_LOCALE, type Locale } from "@/lib/i18n";

const blogAssetModules = import.meta.glob<AssetPointer>(
  "../assets/iso/blog/*.svg.asset.json",
  { eager: true, import: "default" },
);

export const BLOG_ILLUSTRATION_URLS = Object.fromEntries(
  Object.entries(blogAssetModules).flatMap(([path, asset]) => {
    const fileName = path.split("/").pop();
    const slug = fileName?.replace(/\.svg\.asset\.json$/, "");
    return slug && asset?.url ? [[slug, asset.url]] : [];
  }),
) as Record<string, string>;

/**
 * Cover for a blog article: the CMS cover wins, the bundled isometric SVG is
 * only a fallback for articles that have no cover yet.
 */
export function blogIllustrationUrl(slug: string, coverUrl?: string | null): string | null {
  const cover = coverUrl?.trim();
  if (cover) return cover;
  return BLOG_ILLUSTRATION_URLS[slug] ?? null;
}

const ALT_PREFIX: Record<Locale, string> = {
  en: "Isometric illustration for",
  de: "Isometrische Illustration zu",
  fr: "Illustration isométrique pour",
  it: "Illustrazione isometrica per",
  pl: "Ilustracja izometryczna do",
  uk: "Ізометрична ілюстрація до",
  ar: "رسم توضيحي إيزومتري لـ",
  hi: "इसके लिए आइसोमेट्रिक चित्रण",
  uz: "Izometrik illyustratsiya:",
  th: "ภาพประกอบไอโซเมตริกสำหรับ",
  ur: "اس کے لیے آئسومیٹرک مثال",
};

export function blogIllustrationAlt(locale: string, title: string): string {
  const localeKey = locale in ALT_PREFIX ? (locale as Locale) : DEFAULT_LOCALE;
  return `${ALT_PREFIX[localeKey]} ${title}`;
}
